import React from 'react';
import { Toasts } from 'decentraland-ui/dist/components/Toasts/Toasts';
import { Toast } from 'decentraland-ui/dist/components/Toast/Toast';
export default class ToastProvider extends React.PureComponent {
    static defaultProps = {
        children: null
    };
    getCloseHandler = (id) => {
        return () => this.props.onClose(id);
    };
    render() {
        const { children, toasts, position: defaultPosition } = this.props;
        const ToastComponents = [];
        let position = defaultPosition;
        for (const id in toasts) {
            const toast = toasts[id];
            position = toast.position ?? position;
            if (!toast) {
                throw new Error(`Couldn't find a toast for id "${id}"`);
            }
            ToastComponents.push(React.createElement(Toast, { key: id, type: toast.type, title: toast.title, body: toast.body, closable: toast.closable, timeout: toast.timeout, icon: toast.icon, className: toast.className, onClose: this.getCloseHandler(toast.id) }));
        }
        return (React.createElement(React.Fragment, null,
            children,
            React.createElement(Toasts, { position: position }, ToastComponents)));
    }
}
//# sourceMappingURL=ToastProvider.js.map